/**
 * A full-page navigation to another origin - the API's authorize endpoint, which then redirects to
 * the MCP client's loopback callback. Its own module so a spec can replace it: jsdom's
 * `window.location` cannot be redefined.
 */
export const navigateExternal = (url: string): void => {
  window.location.assign(url);
};
